import { RootState } from '@store/index'
import { ModalItem } from '@store/reducers/modal-reducer'

export const selectModals = (state: RootState): ModalItem[] => state.modalState.modals
